// Homepage.jsx

import React, {useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer'
import logo_futek from '../assets/futeklogo.png'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../styles/HomePage.css'; // Make sure this line is present
import slide1 from '../assets/slide1.png'; // Replace with your own paths
import slide2 from '../assets/slide2.png';
import slide3 from '../assets/slide3.webp';
import slide4 from '../assets/slide4.png';
import slide5 from '../assets/slide5.webp';
import slide6 from '../assets/slide6.png';

import { FaWifi, FaCogs, FaPhoneAlt, FaMapMarkerAlt} from 'react-icons/fa';

import image1 from '../assets/image1.png';
import image2 from '../assets/image2.png';
import image3 from '../assets/image3.png';
import image4 from '../assets/image4.png';
import image5 from '../assets/image5.png';
import image6 from '../assets/image6.png';
import industry from '../assets/industry.png'

import latest1 from '../assets/latest1.png'
import latest2 from '../assets/latest2.png'
import latest3 from '../assets/latest3.png'
import latest4 from '../assets/latest4.png'
import latest5 from '../assets/latest5.png'
import latest6 from '../assets/latest6.jpg'
import latest7 from '../assets/latest7.png'
import latest8 from '../assets/latest8.png'

import ford from '../assets/ford.jpg'
import parleagro from '../assets/parleagro.png'
import saintgobain from '../assets/saintgobain.png'
import raymond from '../assets/raymond.png'
import sunbeam from '../assets/sunbeam.jpg'
import tata_motors from '../assets/tata_motors.jpg'
import bhel from '../assets/bhel.png'
import { FaEnvelope, FaLocationPin } from 'react-icons/fa6';



const slides = [
  {
    image: slide1,
    title: 'Precision positioning',
    description:
      'Photoelectric sensor | Optical fiber sensor | Inductive sensor Capacitive sensor | Magnetic sensor | Ultrasonic sensor | Precision contact sensor',
    buttons: [
      { text: 'Learn More', link: '/PositionSensor' },
      { text: 'Our Products', link: '/products' },
    ],
  },
  {
    image: slide2,
    title: 'Displacement measurement',
    description:
      'Triangular laser | Color confocal | Area measurement | Laser correction inner diameter | Outer diameter | Curved surface | Glass | Mirror surface',
    buttons: [
      { text: 'Learn More', link: '#' },
      { text: 'Our Products', link: '/products' },
    ],
  },
  {
    image: slide3,
    title: 'Al image recognition',
    description:
      'Intelligent reading and counting of front and back | Defect detection built-in megapixel image sensor combined with self-developed advanced sampling',
    buttons: [
      { text: 'Learn More', link: '/AiImageRecognition' },
      { text: 'Our Products', link: '/products' },
    ],
  },
  {
    image: slide4,
    title: 'Regional Security',
    description:
      'Level 4 safety light curtain, TUV certified, suitable for safety protection inhigh-risk places TOF safety obstacle avoidance radar with a scanning',
    buttons: [
      { text: 'Learn More', link: '/SafetySensor' },
      { text: 'Our Products', link: '/products' },
    ],
  },
  {
    image: slide5,
    title: 'Automation for a Better Tomorrow.',
    description:
      'Fu-Tek Automation: Innovating Quality Products for a Smarter Tomorrow.',
    buttons: [
      { text: 'Learn More', link: '#' },
      { text: 'Our Products', link: '/products' },
    ],
  },
  {
    image: slide6,
    title: 'Automation solution for renewable energy',
    description:
      'Solar | Wind | Bio-Gas | Hydropower | Geothermal | Hydrogen',
    buttons: [
      { text: 'Learn More', link: '#' },
      { text: 'Our Products', link: '/products' },
    ],
  },
];


const products = [
  {
    image: image1,
    title: 'Position sensors',
    icon: <FaWifi />,
    description: 'Position sensors is a diverse subject that derives its breadth from the need to design and manufacture everything from small ...',
    link: '/PositionSensor'  // Example link for Read More
  },
  {
    image: image2,
    title: 'Process sensors / Fluid sensors',
    icon: <FaCogs />,
    description: 'Process sensors / Fluid sensors is a diverse subject that derives its breadth from the need to design and manufacture ...',
    link: '/ProcessFluidSensors'
  },
  {
    image: image3,
    title: 'AI Image Recognition',
    icon: <FaCogs />,
    description: 'Al Image Recognition is a diverse subject that derives its breadth from the need to design and manufacture everything from ...',
    link: '/AiImageRecognition'
  },
  {
    image: image4,
    title: 'Code Reader',
    icon: <FaCogs />,
    description: 'Code Reader is a diverse subject that derives its breadth from the need to design and manufacture everything from small ...',
    link: '/CodeReaderNew'
  },
  {
    image: image5,
    title: 'Test Box',
    icon: <FaCogs />,
    description: 'Portable Multi-function Sensor Tester. WT/WD Series.',
    link: '/TestBox'
  },
  {
    image: image6,
    title: 'Ultrasonic Flow Meter (Clamp on Type)',
    icon: <FaCogs />,
    description: 'Minimize downtime | Suitable for Non Conductive Media | High Temperature Application | High Accuracy | No pressure drop for energy loss | Low maintenance',
    link: '/products/FlowSensorsFlowMeters'
  }
];

const partnerLogos = [tata_motors, ford, parleagro, saintgobain, raymond, sunbeam, bhel];

const Homepage = () => {


  const [email, setEmail] = useState('');

const handleSubmit1 = (e) => {
  e.preventDefault();

  if (!email) {
    alert('Please enter your email address.');
    return;
  }

  const subject = "Request for Quote";
  const body = `Hello,\n\nI would like a quote. My email is: ${email}`;
  const mailtoLink = `mailto:sales@fu-tekautomation.co.in?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  window.location.href = mailtoLink;

  setEmail('');
};

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit2 = (e) => {
    e.preventDefault();

    const { name, email, subject, phone, message } = formData;
    const text = `*I am interested in your automation solutions. Please contact me:*\n\n*Name:* ${name}\n*Email:* ${email}\n*Phone:* ${phone}\n*Subject:* ${subject}\n*Message:* ${message}`;

    const encodedText = encodeURIComponent(text);
    const phoneNumber = '917046062908'; // Replace with valid number in international format

    window.open(`https://wa.me/${phoneNumber}?text=${encodedText}`, '_blank');
  };
  



  return (
    <div className="homepage">
    <Header />
    <div className="hero-slider">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        // pagination={{ clickable: true }}
        autoplay={{ delay: 4000 }}
        loop={true}
        className="h-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="caption">
                <h1>{slide.title}</h1>
                <p>{slide.description}</p>
                <div className="buttons">
                  {slide.buttons.map((btn, i) => (
                    <a key={i} href={btn.link} className="btn">
                      {btn.text}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>

<section className="our-products-section">
<Swiper
  modules={[Autoplay, Pagination, Navigation]}
  spaceBetween={30}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false
  }}
  pagination={{ clickable: true }}
  // navigation={true}
  breakpoints={{
    320: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  }}
  className="our-products-swiper"
>        {products.map((product, index) => (
          <SwiperSlide key={index}>
            <div className="product-landscape-card">
              <div className="card-image">
                <img src={product.image} alt={product.title} />
                <div className="card-hover-overlay">
                  <p>{product.description}</p>
<div className="card-hover-overlay">
  <p>{product.description}</p>
  <a href={product.link} className="read-more">Read More &rsaquo;</a>
</div>
                </div>
              </div>
              <h4>{product.title}</h4>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
    
    <div className="welcome-section">
  <div className="welcome-content">
    <div className="welcome-text">
      <h2>WELCOME TO<br />FU-TEK AUTOMATION</h2>
      <p>
        Our goal is to exceed the expectations of every customer by offering innovative industrial automation solutions, outstanding customer service and greater value addition, thereby optimizing process functionality and improving operation efficiency of the industry.
      </p>
      <p>
        FU-TEK AUTOMATION serves nearly 100 customers in about 20 vertical industrial segments, offering products, solutions and services through 5 regional offices and a wide network of Dealers and System Integrators.
      </p>
      <button className="read-more-btn">Read More</button>
    </div>
    <div className="welcome-image">
      <img src={industry} alt="Industry 4.0" />
    </div>
  </div>
</div>

<div className="latest-products-section">
  <h2 className="section-title">Our Latest Products</h2>
  <div className="latest-products-grid">
    {[
      {
        title: "Inductive / Capacitive",
        desc: "Wide operating temperature range reduced storage due to a wide range of applications",
        image: latest1,
        link: "/products/InductiveSensor"
      },
      {
        title: "Photoelectric Sensor",
        desc: "Available in a variety of models, like thin type, square type, etc.",
        image: latest2,
        link: "/products/PhotoelectricSensors"
      },
      {
        title: "Magnetic sensors",
        desc: "Non-contact, reliable and solid, abundant types Micron response speed, high measurement sensitivity",
        image: latest3,
        link: "/products/MagneticSensor"
      },
      {
        title: "Ultrasonic Sensor",
        desc: "An all-rounder with a wide range of objects. Measuring distance up to 50m, millimeter accuracy",
        image: latest4,
        link: "/products/UltrasonicSensor"
      },
      {
        title: "Area Sensor",
        desc: "Adopting line synchronization mode with safe and reliable performance.",
        image: latest5,
        link: "/products/AreaObstacleAvoidanceSensor"
      },
      {
        title: "Lidar Sensor",
        desc: "360 laser scanner with high range and resolution for object detection and enhanced safety",
        image: latest6,
        link: "/products/AreaObstacleAvoidanceSensor"
      },
      {
        title: "Flow sensors",
        desc: "For liquids and gases. Versions for the use in hygienic and non-hygienic applications.",
        image: latest7,
        link: "/products/FlowSensorsFlowMeters"
      },
      {
        title: "Pressure Sensors",
        desc: "Sensors and transmitters with integrated evaluation specially for the use in hygienic and non-hygienic apps.",
        image: latest8,
        link: "/products/ProcessFluidSensors"
      },
    ].map((product, index) => (
      <div className="latest-product-card" key={index}>
          <a href={product.link} key={index} className="latest-product-card">
    <img src={product.image} alt={product.title} />
    <h3>{product.title}</h3>
    <p>{product.desc}</p>
  </a>
      </div>
    ))}
  </div>
</div>

      {/* Contact + Quote Section */}
      <div className="quote-section1">
        <div className="quote-banner">
          <h2>REQUEST A QUOTE</h2>
          <p>Sign up for our newsletter and follow us on social media</p>
          <div className="quote-input">
 <form className="quote-input" onSubmit={handleSubmit1}>
      <input
        type="email"
        placeholder="Your email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <button type="submit">➤</button>
    </form>
              </div>
        </div>
        <div className="contact-container">
          <div className="contact-left">
            <img src={logo_futek} alt="FU-TEK Automation Logo" />
            <p>
              Over 24 years experience and knowledge international standards,
              technologically changes our industrial system, we are dedicated to
              provides the best solutions to our valued customers there are
              many variations solutions.
            </p>
            <p><strong><FaPhoneAlt /> +91 7046062908</strong><br />Mon–Fri, 9am until 6pm</p>
            <p><strong><FaEnvelope /> sales@fu-tekautomation.co.in</strong><br />We reply within 24 hours</p>
            <p><FaMapMarkerAlt /> 38, 4th Floor, Shree Siddheshwar Plaza, nr. SARDAR ESTATE,<br />New VIP Road, Vadodara, Gujarat 390019</p>
          </div>

<div className="contact-right">
      <h3>Contact Us</h3>
      <form onSubmit={handleSubmit2}>
        <div className="form-row">
          <input
            type="text"
            name="name"
            placeholder="Enter Name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Enter Email"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-row">
          <input
            type="text"
            name="subject"
            placeholder="Enter Subject"
            required
            value={formData.subject}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Enter Phone"
            required
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <textarea
          name="message"
          placeholder="Message"
          required
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        <button type="submit">Send Now</button>
      </form>
    </div>
    
    
      </div>
    </div>

 {/* Embedded Map Section */}
 <div className="map-section">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0203520220093!2d73.22962927498442!3d22.315070042360507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fcf82d79c3915%3A0x5f630a6c10baeb68!2sShree%20Siddheshwar%20Plaza%201%20%26%202!5e0!3m2!1sen!2sin!4v1747759898475!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        {/* <div className="map-overlay">
          <div>
            <p><strong>📞 +917046062908</strong><br />Mon–Fri, 9am until 6pm</p>
          </div>
          <div>
            <p><strong>✉️ sales@fu-tekautomation.co.in</strong><br />We reply within 24 hours</p>
          </div>
          <div>
            <p>📍 38, 4th Floor, Shree Siddheshwar Plaza, nr. SARDAR ESTATE,<br />New VIP Road, Vadodara, Gujarat 390019.</p>
          </div>
        </div> */}
      </div>

{/* Partners Section with Swiper */}
<div className="partners-section">
        <h2>Our Awesome Partners</h2>
        <Swiper
  modules={[Autoplay]}
  spaceBetween={120}
  slidesPerView={5}
  loop={true}
  autoplay={{ delay: 2000, disableOnInteraction: false }}
>
  {partnerLogos.map((logo, index) => (
    <SwiperSlide key={index}>
      <div className="partner-logo-slide">
        <img src={logo} alt={`Partner ${index + 1}`} />
      </div>
    </SwiperSlide>
  ))}
</Swiper>

      </div>

<Footer />

    </div>
  );
};

export default Homepage;
